import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { first } from 'rxjs/internal/operators/first';

@Injectable()
export class AuthService {
  constructor(public afAuth: AngularFireAuth) { }

  async google(){
    try{
      return this.afAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
    } catch (error) {
      console.log(error);
    }
  }

  async facebook(){
    try{
      return this.afAuth.signInWithPopup(new firebase.auth.FacebookAuthProvider());
    } catch (error) {
      console.log(error);
    }
  }

  getCurrentUser(){
    return this.afAuth.authState.pipe(first()).toPromise()
  }

  async logout(){
    try{
      this.afAuth.signOut();
    }catch(error){
      console.log(error);
    };
  }
}
